import { Component, OnInit, AfterViewInit, ElementRef, HostListener } from '@angular/core';
import { CookieService } from '../cookie.service';
import { StaticFileService } from '../static-file.service';

declare var SnapStates;

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.css']
})
export class NavComponent implements OnInit, AfterViewInit {
  public menuState: boolean;
  public cartNumber: string;
  private menuIcon: any;

  constructor(private el: ElementRef, private cookieService: CookieService, public staticFileService: StaticFileService) { }

  ngOnInit() {
    this.menuState = false;
    this.cartNumber = this.cookieService.getCartNumberItems().toString();
    this.cookieService.cartNumber.subscribe((evt) => {
      this.handleCartNumberChange(evt);
    });
  }

  ngAfterViewInit() {
    this.initSnapSvg();
    this.menuIcon = this.el.nativeElement.querySelector('#icon-hamburger');
  }

  private initSnapSvg() {
    const iconHamburgerSVG = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421;" xml:space="preserve" version="1.1" viewBox="0 0 44 50" height="100%" width="100%"><g><path class="hamburger-middle" d="m 2.1950228,32.2762 c 0.7228108,0 0.9012826,-0.06247 1.0262129,-1.320691 C 3.5781793,28.135654 4.4794619,27.0559 6.8799076,27.0559 L 33.043873,27.01128 c 4.613496,0 7.736753,0.09816 8.638036,0.09816 1.017289,0 1.499163,-0.116007 1.499163,-1.079755 0,-1.079754 -1.865031,-3.096485 -3.060792,-6.755157 -0.419408,-1.258227 -0.660345,-1.320692 -1.320691,-1.320692 -0.481874,0 -0.660346,0.178472 -0.901283,0.901283 -0.838817,2.275515 -1.981037,3.123256 -5.2203,3.123256 H 6.1570968 c -1.9185719,0 -2.5164524,-0.544339 -2.873396,-1.624093 -0.4283323,-1.499163 -0.6603456,-1.561628 -1.2046846,-1.561628 -1.0172893,0 -1.32961495,0.12493 -1.14221956,1.7401 C 1.16881,23.834484 1.2937402,28.251661 1.0528033,30.955509 0.93679664,31.972798 1.1777336,32.2762 2.1950228,32.2762 Z" style="fill:#f2ece2;fill-rule:nonzero;stroke-width:8.92358971;fill-opacity:1"/><path class="hamburger-top" style="fill:#f2ece2;fill-rule:nonzero;stroke-width:8.92358971;fill-opacity:1" d="m 2.1950228,15.2556 c 0.7228108,0 0.9012826,-0.06246 1.0262129,-1.320691 C 3.5781793,11.115054 4.4794619,10.0353 6.8799076,10.0353 L 33.043873,9.9906821 c 4.613496,0 7.736753,0.09816 8.638036,0.09816 1.017289,0 1.499163,-0.1160069 1.499163,-1.0797547 0,-1.0797544 -1.865031,-3.0964857 -3.060792,-6.7551576 -0.419408,-1.25822619 -0.660345,-1.32069132 -1.320691,-1.32069132 -0.481874,0 -0.660346,0.17847182 -0.901283,0.90128262 -0.838817,2.2755154 -1.981037,3.1232565 -5.2203,3.1232565 H 6.1570968 c -1.9185719,0 -2.5164524,-0.544339 -2.873396,-1.6240934 C 2.8553685,1.8345209 2.6233552,1.7720557 2.0790162,1.7720557 1.0617269,1.7720557 0.74940125,1.896986 0.93679664,3.5121558 1.16881,6.8138841 1.2937402,11.231061 1.0528033,13.934909 0.93679664,14.952198 1.1777336,15.2556 2.1950228,15.2556 Z" /></g><path class="hamburger-bottom" d="m 2.1950228,49.3096 c 0.7228108,0 0.9012826,-0.06247 1.0262129,-1.320691 C 3.5781793,45.169054 4.4794619,44.0893 6.8799076,44.0893 L 33.043873,44.04468 c 4.613496,0 7.736753,0.09816 8.638036,0.09816 1.017289,0 1.499163,-0.116007 1.499163,-1.079755 0,-1.079754 -1.865031,-3.096485 -3.060792,-6.755157 -0.419408,-1.258227 -0.660345,-1.320692 -1.320691,-1.320692 -0.481874,0 -0.660346,0.178472 -0.901283,0.901283 -0.838817,2.275515 -1.981037,3.123256 -5.2203,3.123256 H 6.1570968 c -1.9185719,0 -2.5164524,-0.544339 -2.873396,-1.624093 -0.4283323,-1.499163 -0.6603456,-1.561628 -1.2046846,-1.561628 -1.0172893,0 -1.32961495,0.12493 -1.14221956,1.7401 C 1.16881,40.867884 1.2937402,45.285061 1.0528033,47.988909 0.93679664,49.006198 1.1777336,49.3096 2.1950228,49.3096 Z" style="fill:#f2ece2;fill-rule:nonzero;stroke-width:8.92358971;fill-opacity:1"/></svg>';
    const iconHamburger = {
      selector: '.icon-hamburger',
      svg: iconHamburgerSVG,
      transitionTime: 250,
      states: {
        open: [
            { id: 'top-lower', element: '.hamburger-top', y: 17 },
            { id: 'bottom-raise', element: '.hamburger-bottom', y: -17 },
            { waitFor: 'top-lower', element: 'g', r: 45 },
            { waitFor: 'top-lower', element: '.hamburger-bottom', r: -45},
        ],
        closed: [
            { id: 'top-angle', element: 'g', r: 0 },
            { id: 'bottom-angle', element: '.hamburger-bottom', r: 0 },
            { waitFor: 'top-angle', element: '.hamburger-top', y: 0 },
            { waitFor: 'bottom-angle', element: '.hamburger-bottom', y: 0 },
        ]
      },
      events: [
        {event: 'click', state: ['open', 'closed']}
      ]
    };
    SnapStates(iconHamburger);
  }

  public toggleMenu(state?: boolean) {
    this.menuState = typeof(state) === 'undefined' ? !this.menuState : state;
  }

  public itemSelected() {
    this.menuIcon.click();
  }

  private handleCartNumberChange(evt: any) {
    const counter = evt.num;
    const animate = evt.animate;
    if(animate) {
      this.toggleMenu(true);
        setTimeout(function(that){
          that.cartNumber = counter;
          // ... i'm not proud of the hackjob i'm implmenting
          // here, i realize it's barbarism. if you're reading
          // this just look away please, it's rude to stare
          setTimeout(function(thatthat){
            thatthat.toggleMenu(false);
          }, 450, that);
      }, 450, this);
    } else {
      this.cartNumber = counter;
    }
  }

  @HostListener('window:popstate', ['$event'])
    onPopState(event) {
      if (this.menuState) {
        this.menuIcon.click();
      }
    }

}
